// ===============  plugin import ============== //
import { useState } from 'react';

// =============== component import ============= //
import ServiceSetup from './component/serviceSetup/ServiceSetup';
import AttributeSetup from './component/attributeSetup/AttributeSetup';
import AssociateServicesWithAttributes from './component/associateServicesWithAttributes/AssociateServicesWithAttributes';
import ServiceAttributeAssociation from './component/serviceAttributeAssociation/ServiceAttributeAssociation';

const Step4 = (props) => {
    const {
        formValidateError,
        formData
    } = props;

    const infoPopupData = {
        'service_setup' : {
            'title' : 'Service setup',
            'info' : `Use this Action Type when you want to collect a set of information for fulfilling a service request. For example, to fulfill a purchase request, you need to collect information about product, collect payment details, know the shipping address before placing an order. Or for a Hotel Room, you need to finalize the Room Type, Dates, No of Guests, Guest details, payment etc before booking a room.`,
        },
        'associate_services_with_attributes': {
            'title' : 'Associate services with attributes',
            'info' : `Use this to match the Attributes with the Services that you have created.`
        }
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }

    // ------ define all state here ----- //
    const [productFeatureAssApiIsCall, setProductFeatureAssApiIsCall] = useState(false);
    const [pfAssSetupApiIsCall, setPfAssSetupApiIsCall] = useState(false)

    return (
        <>
            <div>
                <ServiceSetup
                    formData={formData}
                    formValidateError={formValidateError}
                    isInfoOpenHandler={props.isInfoOpenHandler}
                    infoOpenOnCLick={infoOpenOnCLick}
                    onInputChange={props.onInputChange}
                    productFeatureAssociationApiCall={(param) => setProductFeatureAssApiIsCall(param)}
                    serviceAttributeAssSetupApiCall={(param) => setPfAssSetupApiIsCall(param) }
                />
            </div>
            <div>
                <AttributeSetup
                    formData={formData}
                    formValidateError={formValidateError}
                    onInputChange={props.onInputChange}
                    isInfoOpenHandler={props.isInfoOpenHandler}
                    productFeatureAssociationApiCall={(param) => setProductFeatureAssApiIsCall(param)}
                    serviceAttributeAssSetupApiCall={(param) => setPfAssSetupApiIsCall(param) }
                />
            </div>
            <div>
                <AssociateServicesWithAttributes
                    formData={formData}
                    formValidateError={formValidateError}
                    infoOpenOnCLick={infoOpenOnCLick}
                    onInputChange={props.onInputChange}
                    productFeatureAssApiIsCall={productFeatureAssApiIsCall}
                    serviceAttributeAdd={(param) => setProductFeatureAssApiIsCall(param)}
                    serviceAttributeAssSetupApiCall={(param) => setPfAssSetupApiIsCall(param) }
                />
            </div>
            <div>
                <ServiceAttributeAssociation
                    formData={formData}
                    formValidateError={formValidateError}
                    onInputChange={props.onInputChange}
                    pfAssSetupApiIsCall={pfAssSetupApiIsCall}
                    associationSetupIsRefresh={(param)=> setPfAssSetupApiIsCall(param)}
                    isInfoOpenHandler={props.isInfoOpenHandler}
                />
            </div>
        </>
    )
}

export default Step4